import ScrollableWrapper from './ScrollableWrapper'

export * from './ScrollableWrapper'
export default ScrollableWrapper
